
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Default to mobile for SSR (server-side rendering)
    if (typeof window === 'undefined') return true
    return window.innerWidth < MOBILE_BREAKPOINT
  })

  React.useEffect(() => {
    if (typeof window === 'undefined') return
    
    const checkSize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    window.addEventListener('resize', checkSize)
    
    // Initial check
    checkSize()
    
    return () => window.removeEventListener('resize', checkSize)
  }, [])

  return isMobile
}
